import React from "react";
export const EmptyBasket = () => {
    return (React.createElement("div", { className: "flex flex-col items-center justify-center h-full" },
        React.createElement("div", { className: "text-2xl font-bold" }, "Your basket is empty"),
        React.createElement("div", { className: "text-sm text-gray-500" }, "Add some items to your basket")));
};
